import PropTypes from 'prop-types'
import React from 'react'

import { DynamicImageStyled, TubeWrapper } from './styles'

const TubeSpit = ({ path }) => {
  return (
    <TubeWrapper>
      <DynamicImageStyled
        image={`${path}tube_spit`}
        imageSizes={{
          xs: 300,
          md: 400,
        }}
        imageType="png"
        alt="tube spit"
      />
    </TubeWrapper>
  )
}

TubeSpit.propTypes = {
  path: PropTypes.string.isRequired,
}

export default TubeSpit
